


interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const energyboost: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} = {
    "en": {
        "url": "energy-boost-iv-drip",
        "meta": {
            "title": "Energy Boost IV Drip in Dubai | Elite Body Home",
            "description": "Combat fatigue and recharge your energy levels with our specialized IV therapy designed to restore vitality and mental clarity.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/energy-boost-iv-drip/",
            "og": {
                "title": "Energy Boost IV Drip in Dubai | Elite Body Home",
                "description": "IV therapy to combat fatigue and restore energy levels quickly",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-50.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Energy Boost IV Drip"],
        "hero": {
            "title": "Energy Boost IV Drip in Dubai",
            "subtitle": "Fatigue Relief Therapy",
            "description": "In modern world, the most common problem for people is the feeling of constantly tired and drained of energy. So, whether you're suffering from chronic stress, recovering from sickness, or experiencing the day-to-day effects of a busy lifestyle, an Energy Boost IV might be just what you need! IV (intravenous) therapy infuses essential nutrients into your bloodstream, yielding a quick fix to restore energy to the body for a more productive you."
        },
        "howItWorks": {
            "title": "How Does Energy Boost IV Drip Work?",
            "description": "The Energy Boost IV Drip is an extremely effective way to replenish your body's energy reserves through the intravenous administration of vitamins, minerals, and other key nutrients. Because it is given through an IV, the nutrients skip the digestive tract, so they are quickly absorbed by the body and often go to work straight away."
        },
        "procedureSteps": {
            "heading": "Procedure Overview",
            "para": "Here's what to expect during your Energy Boost IV Drip session:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "A health worker analyzes your health and energy needs to make sure that remedy is right for you.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "Preparation",
                    "desc": "The IV infusion contains a mixture of energy-supportive vitamins, minerals and even electrolytes.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "IV Insertion",
                    "desc": "A trained healthcare provider will insert a small, sterile needle into your arm to start the infusion.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Infusion Process",
                    "desc": "The IV drip takes about 30 - 60 minutes and the nutrients are injected directly into your bloodstream for immediate and effective results.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Post-Treatment",
                    "desc": "Once the infusion is finished, they remove the needle and you might sit for a moment. Most clients report feeling noticeably uplifted right after the session.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Energy Boost IV Drip",
            "subheading": "Experience restored energy and vitality",
            "para": "The Energy Boost IV Drip has many health benefits for people that have demanding lives or chronic fatigue. Not only does this treatment help restore your body's vitamins and minerals, but it also offers many extra benefits.",
            "items": [
                {
                    "title": "Instant Energy Boost",
                    "desc": "Increase energy & battle exhaustion, better athletic performance, and general health.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Improved Mental Clarity",
                    "desc": "They are 100% bioavailable meaning they work quicker and have superior results as they bypass the digestive system.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "Enhanced Immune System",
                    "desc": "Assists the body in fighting infection and recovering faster.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Increased Metabolism",
                    "desc": "Helps with energy production and metabolic function.",
                    "icon": "fa-solid fa-fire"
                },
                {
                    "title": "Stress Relief",
                    "desc": "Counters physical effects of stress by replacing depleted nutrients.",
                    "icon": "fa-solid fa-cloud"
                },
                {
                    "title": "Reduced Fatigue",
                    "desc": "Reduces lethargy inducing feelings by increasing healthiness.",
                    "icon": "fa-solid fa-bed"
                }
            ]
        },

        "eligibility": {
            "heading": "Who Can Benefit from Energy Boost IV Drip?",
            "subheading": "",
            "para": "Recommended For: The Energy Boost IV is appropriate for anyone, specifically those affected by fatigue, burnout or nutrient deficiency. But you need to assess your health requirements before undergoing the treatment.",
            "items": [
                {
                    "title": "People prone to chronic fatigue",
                    "desc": "Perfect for those who always seem to run out of energy.",
                    "icon": "fa-solid fa-tired"
                },
                {
                    "title": "Busy professionals",
                    "desc": "Those with busy jobs seeking to maintain good energy levels.",
                    "icon": "fa-solid fa-briefcase"
                },
                {
                    "title": "Athletes",
                    "desc": "To recover better and keep energy levels higher during intense training.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "Frequent travelers",
                    "desc": "Particularly those who suffer from jet lag or travel fatigue.",
                    "icon": "fa-solid fa-plane"
                },
                {
                    "title": "Those who lack certain nutrients",
                    "desc": "Derives perfectly for people with vitamin and minerals deficiency because of health reasons or bad foods.",
                    "icon": "fa-solid fa-apple-alt"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Before Your Treatment",
            "subheading": "",
            "para": "It's easy to prepare for an IV Energy Boost session, but by taking some easy steps beforehand, you can make sure you get the most out of your treatment.",
            "items": [
                {
                    "title": "Hydrate",
                    "desc": "Hydrate well before your appointment to facilitate the infusion.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Eat a balanced meal",
                    "desc": "Make sure you have eaten so you don't feel faint.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Disclose any medical conditions",
                    "desc": "Make sure your healthcare provider knows if you have any underlying health conditions or are taking meds.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "Dress comfortably",
                    "desc": "Dress in something loose so that you can slide your arms out easily.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "Most patients feel an immediate boost in energy and mental clarity after being administered the Energy Boost IV. IVs can optimize body functions when nutrients are administered through the IV to enhance your wellness.",
            "items": [
                {
                    "title": "Immediate energy improvement",
                    "desc": "Feel more alert and vibrant.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Sustained energy levels",
                    "desc": "Sustained boost that can last days or weeks",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "Better focus and concentration",
                    "desc": "Improved cognitive function",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "Better recovery",
                    "desc": "A suitable yoga practice for anyone recovering from illness, travel, or stress.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maximize and maintain the benefits of your Energy Boost IV Drip:",
            "items": [
                {
                    "title": "Stay Hydrated",
                    "desc": "Continue drinking plenty of water to help your body process the nutrients.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Monitor Effects",
                    "desc": "Pay attention to how your body responds to the treatment.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "Follow-up Sessions",
                    "desc": "Consider regular treatments for sustained energy benefits.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "Healthy Lifestyle",
                    "desc": "Maintain balanced nutrition and rest to complement the treatment.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long does an Energy Boost IV session take?",
                    "answer": "The infusion typically takes 30-60 minutes to complete."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "You may feel a small pinch when the IV is inserted, but the treatment itself is painless."
                },
                {
                    "question": "How soon will I feel results?",
                    "answer": "Many patients report feeling increased energy immediately after the session."
                },
                {
                    "question": "How often should I get this treatment?",
                    "answer": "Frequency depends on your individual needs - our healthcare providers can recommend a schedule during consultation."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Side effects are rare but may include minor bruising at the injection site."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-fesfService-Banner-Image-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 7,
            "title": "Energy Boost IV Drip in Dubai",
            "description": "Combat fatigue and recharge your energy levels with our specialized IV therapy designed to restore vitality and mental clarity.",
            "price": 599
        }
    },
    "ar": {
        "url": "energy-boost-iv-drip",
        "meta": {
            "title": "تعزيز الطاقة بالتنقيط الوريدي في دبي | ايليت بودي هوم",
            "description": "علاج متخصص لمكافحة الإرهاق واستعادة مستويات الطاقة من خلال حقن الفيتامينات والمعادن مباشرة في مجرى الدم.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/energy-boost-iv-drip",
            "og": {
                "title": "تعزيز الطاقة بالتنقيط الوريدي في دبي | ايليت بودي هوم",
                "description": "علاج وريدي لمحاربة الإرهاق واستعادة مستويات الطاقة بسرعة",
                "image": "https://www.elitebodyhome.com/images/energy-boost-iv-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "تعزيز الطاقة بالتنقيط الوريدي"],
        "hero": {
            "title": "تعزيز الطاقة بالتنقيط الوريدي",
            "subtitle": "علاج التخلص من الإرهاق",
            "description": "يعاني الكثير في عالمنا المعاصر من الشعور المستمر بالإرهاق ونقص الطاقة. قد يكون التنقيط الوريدي هو الحل الأمثل لك سواء كنت تواجه إجهادًا مزمنًا، أو تتعافى من المرض، أو تواجه تأثيرات أسلوب الحياة المزدحم. تعتمد تقنية التنقيط الوريدي على إيصال العناصر الغذائية الأساسية مباشرةً إلى مجرى الدم، مما يمنح الجسم دفعة سريعة من الطاقة ويعيد لك نشاطك وإنتاجيتك خلال وقت قصير."
        },
        "howItWorks": {
            "title": "كيف يعمل علاج تعزيز الطاقة بالتنقيط الوريدي؟",
            "description": "يُعد علاج تعزيز الطاقة بالتنقيط الوريدي وسيلة فعالة للغاية لتعويض نقص الطاقة في الجسم، وذلك من خلال العلاج الوريدي بالفيتامينات ومضادات الأكسدة والمعادن والعناصر الغذائية الحيوية. ونظراً لأن هذه المغذيات تُحقن مباشرة في مجرى الدم، فإنها تتجاوز الجهاز الهضمي، مما يسمح بامتصاصها السريع واستفادة الجسم منها على الفور تقريباً."
        },
        "procedureSteps": {
            "heading": "خطوات الإجراء",
            "para": "إليك ما يمكن توقعه خلال جلسة العلاج:",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "يقوم أحد الأطباء بتقييم حالتك الصحية العامة واحتياجاتك من الطاقة للتأكد من أن العلاج مناسب لك.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "التحضير",
                    "desc": "تحتوي التركيبة الوريدية على مجموعة من الفيتامينات والمعادن والإلكتروليتات التي تدعم مستويات الطاقة في الجسم.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "إدخال الإبرة الوريدية",
                    "desc": "تُدخل إبرة صغيرة ومعقمة في الذراع بواسطة متخصص مؤهل لبدء عملية التنقيط الوريدي.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "التنقيط الوريدي",
                    "desc": "تستغرق الجلسة حوالي 30 إلى 60 دقيقة، يتم خلالها ضخ العناصر الغذائية مباشرةً إلى مجرى الدم، مما يعطي نتائج فورية وفعالة.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "الرعاية اللاحقة",
                    "desc": "تُزال الإبرة بعد انتهاء الجلسة، وقد يُطلب منك الراحة لبضع دقائق. يشعر معظم العملاء بانتعاش وارتفاع ملحوظ في مستويات الطاقة فوراً بعد العلاج.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد العلاج",
            "subheading": "استمتع بطاقة متجددة وحيوية",
            "para": "تُقدم جلسة العلاج بالفيتامينات الوريدية فوائد صحية متعددة، خاصة للأشخاص الذين يعيشون حياة مرهقة أو يعانون من الإرهاق المزمن. فهي لا تُعيد فقط توازن الفيتامينات والمعادن في الجسم، بل تقدم أيضًا فوائد إضافية مهمة.",
            "items": [
                {
                    "title": "زيادة فورية في الطاقة",
                    "desc": "تعزز مستويات الطاقة في الجسم، وتساعد في مكافحة الإرهاق، وتحسين الأداء الرياضي، وتعزيز الصحة العامة.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تحسين الصفاء الذهني",
                    "desc": "تُحقن العناصر الغذائية مباشرةً في مجرى الدم بنسبة امتصاص 100%، لذلك يكون مفعولها أسرع ونتائجها أقوى مقارنةً بالمكملات الغذائية التي تؤخذ عن طريق الفم.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "تقوية جهاز المناعة",
                    "desc": "تدعم جلسة العلاج الجسم في مقاومة العدوى والتعافي بشكل أسرع من الأمراض.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "تعزيز عملية التمثيل الغذائي",
                    "desc": "تُساعد على تعزيز عملية إنتاج الطاقة وتحسين وظائف التمثيل الغذائي.",
                    "icon": "fa-solid fa-fire"
                },
                {
                    "title": "تقليل التوتر",
                    "desc": "يعوض العلاج العناصر الغذائية التي يستنزفها التوتر.",
                    "icon": "fa-solid fa-cloud"
                },
                {
                    "title": "تقليل التعب والإرهاق",
                    "desc": "يقلل من الشعور بالخمول ويحسن من الصحة العامة.",
                    "icon": "fa-solid fa-bed"
                }
            ]
        },

        "eligibility": {
            "heading": "من هو المرشح المناسب للعلاج؟",
            "subheading": "",
            "para": "يُعتبر علاج تعزيز الطاقة بالتنقيط الوريدي مناسبًا للجميع، خاصة لأولئك الذين يعانون من التعب أو الإرهاق أو نقص العناصر الغذائية. ومع ذلك، يجب تقييم احتياجاتك الصحية قبل إجراء العلاج.",
            "items": [
                {
                    "title": "الأشخاص الذين يعانون من الإرهاق المزمن",
                    "desc": "يُعد علاج مثالي لأولئك الذين يشعرون دائمًا بالإرهاق أو نقص الطاقة.",
                    "icon": "fa-solid fa-tired"
                },
                {
                    "title": "المهنيون المنشغلون دائمًا",
                    "desc": "يناسب الأشخاص الذين يمتلكون وظائف مُنهكة ويحتاجون للحفاظ على استقرار مستويات طاقة.",
                    "icon": "fa-solid fa-briefcase"
                },
                {
                    "title": "الرياضيون",
                    "desc": "يساعد في تحسين عملية التعافي والحفاظ على مستويات طاقة أعلى أثناء التدريب المكثف.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "المسافرون الدائمون",
                    "desc": "يُعد علاج مفيد بشكل خاص للأشخاص الذين يعانون من اضطراب الرحلات الجوية الطويلة.",
                    "icon": "fa-solid fa-plane"
                },
                {
                    "title": "الأشخاص الذين يعانون من نقص العناصر الغذائية",
                    "desc": "يناسب بشكل مثالي الأشخاص الذين يعانون من نقص الفيتامينات والمعادن بسبب مشكلات صحية أو النظام الغذائي غير المتوازن.",
                    "icon": "fa-solid fa-apple-alt"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل الجلسة",
            "subheading": "",
            "para": "يسهل التحضير لجلسة تعزيز الطاقة بالتنقيط الوريدي، ولكن يجب اتباع بعض الخطوات البسيطة قبل الجلسة، لضمان الاستفادة القصوى من العلاج.",
            "items": [
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "تأكد من شرب كمية كافية من الماء قبل موعد الجلسة لتسهيل الإجراء.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تناول وجبة متوازنة",
                    "desc": "تأكد من تناول وجبة متوازنة لتجنب الشعور بالدوار أو الإغماء أثناء الجلسة.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "الإبلاغ عن أي حالات صحية",
                    "desc": "أخبر مقدم الرعاية الصحية إذا كنت تعاني من أي حالات صحية أساسية أو إذا كنت تتناول أي أدوية.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "ارتداء ملابس مريحة",
                    "desc": "احرص على ارتداء ملابس فضفاضة بحيث تتمكن من سحب ذراعيك بسهولة أثناء العلاج.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "يشعر معظم المرضى بزيادة فورية في مستوى الطاقة وتحسن الصفاء الذهني بعد تلقيهم علاج تعزيز الطاقة بالتنقيط الوريدي، كما يوفر العلاج تحسن وظائف الجسم وتعزيز صحتك العامة.",
            "items": [
                {
                    "title": "تحسين فوري في مستوى الطاقة",
                    "desc": "ستشعر بزيادة النشاط والحيوية على الفور.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تعزيز دائم لمستويات الطاقة",
                    "desc": "يمكن أن يدوم تأثير زيادة الطاقة لأيام أو أسابيع.",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "زيادة التركيز وتحسين الانتباه",
                    "desc": "يساعد العلاج على تحسن الوظائف الإدراكية.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "تحسن في عملية التعافي",
                    "desc": "يناسب العلاج أي شخص يتعافى من المرض أو السفر أو الإجهاد.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "لتعزيز والحفاظ على فوائد علاج تعزيز الطاقة بالتنقيط الوريدي:",
            "items": [
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "استمر في شرب كميات كافية من الماء لمساعدة جسمك على معالجة العناصر الغذائية.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "مراقبة التأثيرات",
                    "desc": "انتبه لاستجابة جسمك للعلاج.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "جلسات المتابعة",
                    "desc": "فكر في الجلسات المنتظمة للحصول على فوائد مستدامة للطاقة.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "نمط حياة صحي",
                    "desc": "حافظ على تغذية متوازنة وراحة كافية لتعزيز تأثيرات العلاج.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تستغرق جلسة تعزيز الطاقة بالتنقيط الوريدي؟",
                    "answer": "يستغرق التسريب عادةً ما بين 30 إلى 60 دقيقة."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "قد تشعر بوخز بسيط عند إدخال الإبرة، لكن العلاج نفسه غير مؤلم."
                },
                {
                    "question": "متى سأشعر بالنتائج؟",
                    "answer": "يذكر العديد من المرضى شعورًا بزيادة الطاقة مباشرةً بعد الجلسة."
                },
                {
                    "question": "كم مرة يجب أن أحصل على هذا العلاج؟",
                    "answer": "يعتمد التكرار على احتياجاتك الفردية - يمكن لمقدمي الرعاية الصحية تقديم توصية خلال الاستشارة."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "الآثار الجانبية نادرة ولكن قد تشمل كدمات طفيفة في موقع الحقن."
                }
            ]
        }
    }
}